import CancelOutlined from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { ConstValues } from '@openx/types/helpers.ts';
import type { ComponentType } from 'react';

export const StatusTone = {
  POSITIVE: 'positive',
  NEGATIVE: 'negative',
} as const;

export type StatusTone = ConstValues<typeof StatusTone>;

export const STATUS_ICONS: Record<StatusTone, ComponentType<SvgIconProps>> = {
  [StatusTone.POSITIVE]: CheckCircleOutlined,
  [StatusTone.NEGATIVE]: CancelOutlined,
};

export const STATUS_MARKS: Record<StatusTone, string> = {
  [StatusTone.POSITIVE]: '✓',
  [StatusTone.NEGATIVE]: '✗',
};

export const STATUS_COLORS: Record<StatusTone, { accent: string; strong: string }> = {
  [StatusTone.POSITIVE]: { accent: 'success.main', strong: 'success.dark' },
  [StatusTone.NEGATIVE]: { accent: 'error.main', strong: 'error.main' },
};
